import React from 'react'

const Header = () => {
    return (
    <>
        <h1 className="header-title">New Albums & Singles</h1>
        <div className="header-line"></div>
    </>
    )
}

export default Header